export { default } from './withInventoryItemRecommendations';
